const useDeviceType = () => {
  const isAndroid = /android/i.test(navigator.userAgent);
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

  const deviceType = isAndroid ? 'android' : isIOS ? 'ios' : null;

  return deviceType;
};

export default useDeviceType;